import React, { useEffect, useMemo, useState } from 'react';
import api from '../../../../utils/api';

const ACTION_OPTIONS = [
  'all',
  'create',
  'approve',
  'reject',
  'reserve',
  'release',
  'participate',
  'brand_budget_consume',
  'clearance_auto_over',
  'combo_validation_reject',
  'coupon_apply',
  'coupon_remove',
  'coupon_used_checkout',
  'seller_own_validation_reject',
  'garage_service_validation_reject',
  'garage_service_capacity_reject',
  'update_garage_service_status',
  'mrp_validation_reject',
  'pool_validation_reject',
  'pool_consume'
];

const DealAuditLogs = () => {
  const [logs, setLogs] = useState([]);
  const [actionFilter, setActionFilter] = useState('all');
  const [loading, setLoading] = useState(false);

  const loadLogs = async (action = 'all') => {
    setLoading(true);
    try {
      const qs = action && action !== 'all' ? `?action=${encodeURIComponent(action)}` : '';
      const res = await api.get(`/admin/deals/audit-logs${qs}`);
      setLogs(Array.isArray(res.data?.data?.logs) ? res.data.data.logs : []);
    } catch (_) {
      setLogs([]);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    loadLogs(actionFilter);
  }, [actionFilter]);

  const rows = useMemo(() => logs, [logs]);

  return (
    <div className="space-y-4">
      <div className="flex items-center justify-between">
        <div>
          <h2 className="text-lg font-bold text-slate-900">Deal Audit Logs</h2>
          <p className="text-xs text-slate-500">Latest deal write actions (max 200)</p>
        </div>
        <select
          value={actionFilter}
          onChange={(e) => setActionFilter(e.target.value)}
          className="px-3 py-2 rounded-lg border border-slate-200 bg-white text-sm"
        >
          {ACTION_OPTIONS.map((a) => <option key={a} value={a}>{a}</option>)}
        </select>
      </div>

      <div className="bg-white rounded-lg border border-slate-100 shadow-sm overflow-hidden">
        {loading ? (
          <div className="p-6 text-sm text-slate-500">Loading logs...</div>
        ) : rows.length === 0 ? (
          <div className="p-6 text-sm text-slate-500">No logs found.</div>
        ) : (
          <div className="overflow-x-auto">
            <table className="w-full">
              <thead className="bg-slate-50">
                <tr>
                  <th className="px-4 py-2 text-left text-[11px] font-bold uppercase tracking-wider text-slate-500">Time</th>
                  <th className="px-4 py-2 text-left text-[11px] font-bold uppercase tracking-wider text-slate-500">Action</th>
                  <th className="px-4 py-2 text-left text-[11px] font-bold uppercase tracking-wider text-slate-500">Actor</th>
                  <th className="px-4 py-2 text-left text-[11px] font-bold uppercase tracking-wider text-slate-500">Meta</th>
                </tr>
              </thead>
              <tbody className="divide-y divide-slate-100">
                {rows.map((log) => (
                  <tr key={log._id}>
                    <td className="px-4 py-2 text-xs text-slate-600">{new Date(log.createdAt).toLocaleString()}</td>
                    <td className="px-4 py-2 text-xs font-semibold text-slate-800">{log.action}</td>
                    <td className="px-4 py-2 text-xs text-slate-700">
                      {log?.actorId?.name || log?.actorId?.email || String(log?.actorId || '')}
                    </td>
                    <td className="px-4 py-2 text-xs text-slate-600">
                      <code>{JSON.stringify(log.meta || {})}</code>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}
      </div>
    </div>
  );
};

export default DealAuditLogs;
